import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Menu.css';

const menuData = {
  starters: [
    { name: 'Spicy Chicken Wing', price: '£4.99' },
    { name: 'Chicken 65 (2)', price: '£6.99' },
    { name: 'Mutton Rolls (2)', price: '£3.99' },
    { name: 'Vegetable Rolls (2)', price: '£3.50' },
    { name: 'Vegetable Samosa (1)', price: '£1.99' },
    { name: 'Anchovy Fish Fry', price: '£6.99' },
    { name: 'King Fish Fry (2)', price: '£8.99' },
    { name: 'Mutton Chukka', price: '£9.99' },
    { name: 'Ceylon Omelette', price: '£3.99' },
    { name: 'Vegetable Pakora (4)', price: '£4.99' },
  ],
  curries: {
    nonVeg: [
      { name: 'Chicken Curry', price: '£7.49' },
      { name: 'Mutton Curry', price: '£9.99' },
      { name: 'Prawn Curry', price: '£9.99' },
      { name: 'Prawn Pepper Fry', price: '£9.99' },
      { name: 'Spicy Ceylon Curry (Mutton/Chicken)', price: '£9.99' },
    ],
    veg: [
      { name: 'Ceylon Dal Curry', price: '£6.99' },
      { name: 'Mixed Vegetable Curry', price: '£6.99' },
      { name: 'Fried Brinjal & Potato Curry', price: '£6.99' },
      { name: 'Paneer Butter Masala', price: '£7.49' },
    ],
  },
  sides: [
    { name: 'French Fries', price: '£3.00' },
    { name: 'Masala Fries', price: '£3.50' },
  ],
  kothu: [
    { name: 'Chicken Kothu', price: '£8.99' },
    { name: 'Mutton Kothu', price: '£10.99' },
    { name: 'Vegetables Kothu', price: '£7.99' },
    { name: 'Idiyappam Mutton Kothu', price: '£10.99' },
    { name: 'Puttu Kothu', price: '£10.99' },
  ],
  biryani: [
    { name: 'Chicken Biryani', price: '£8.99' },
    { name: 'Mutton Biryani', price: '£10.99' },
  ],
  friedRice: [
    { name: 'Steamed Basmati Rice', price: '£2.99' },
    { name: 'Chicken Fried Rice', price: '£7.99' },
    { name: 'Egg Fried Rice', price: '£6.99' },
    { name: 'Sea Food Mixed Fried Rice', price: '£9.99' },
  ],
  noodles: [
    { name: 'Chicken Noodles', price: '£7.99' },
    { name: 'Veg Noodles', price: '£6.99' },
    { name: 'Seafood Mixed Noodles', price: '£9.99' },
  ],
  rotti: [
    { name: 'Pol Rotti With Katta Sambal', price: '£5.99' },
    { name: 'Veechu Rotti', price: '£3.99' },
    { name: 'Button Parotta', price: '£4.99' },
    { name: 'Plain Parotta', price: '£4.50' },
    { name: 'Chappathi', price: '£4.99' },
  ],
  appam: [
    { name: 'Plain Appam', price: '£3.99' },
    { name: 'Pal Appam', price: '£4.99' },
    { name: 'Egg Appam', price: '£5.99' },
    { name: 'Idiyappam (Steamed Hoppers) with Sothi & Sambal', price: '£5.99' },
  ],
  breakfast: [
    { name: 'Masala Dosa', price: '£6.99' },
    { name: 'Ghee Paper Roast', price: '£6.99' },
    { name: 'Onion Dosa', price: '£6.99' },
    { name: 'Plain Dosa', price: '£5.99' },
    { name: 'Rava Dosa', price: '£6.99' },
    { name: 'Cheese Dosa', price: '£7.49' },
    { name: 'Curry Dosa', price: '£9.99' },
    { name: 'Oothapam', price: '£5.99' },
    { name: 'Idly (2) with Sambar & Chutney', price: '£5.99' },
    { name: 'Thayer (Curd Rice) Satham', price: '£5.99' },
    { name: 'Medu Vada (2)', price: '£3.99' },
    { name: 'Masala Vada (2)', price: '£3.99' },
  ],
  drinks: [
    { name: 'Coffee / Tea', price: '£2.99' },
    { name: 'Rose Milk', price: '£2.50' },
    { name: 'Masala Tea', price: '£3.00' },
    { name: 'Mojito Flavour Drinks', price: '£3.50' },
    { name: 'Ginger Plain Tea', price: '£1.99' },
    { name: 'Mango Lassi', price: '£3.50' },
    { name: 'Fresh Juice', price: '£3.99' },
    { name: 'Fruit Salad with Ice Cream', price: '£5.99' },
  ],
};

const Menu = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isFlipping, setIsFlipping] = useState(false);

  const pages = [
    { title: 'Starters / Short Eats', items: menuData.starters },
    { title: 'Non-Veg Curries', items: menuData.curries.nonVeg, subtitle: 'Made with wonderful blend of spices' },
    { title: 'Veg Curries', items: menuData.curries.veg },
    { title: 'Sides', items: menuData.sides },
    { title: 'Kothu Specialties', items: menuData.kothu, subtitle: 'Popular South Indian street food' },
    { title: 'Biryani', items: menuData.biryani },
    { title: 'Fried Rice', items: menuData.friedRice },
    { title: 'Noodles', items: menuData.noodles },
    { title: 'Rotti', items: menuData.rotti },
    { title: 'Appam (Hoppers)', items: menuData.appam },
    { title: 'Breakfast', items: menuData.breakfast },
    { title: 'Drinks', items: menuData.drinks },
  ];

  const nextPage = () => {
    if (currentPage < pages.length - 1 && !isFlipping) {
      setIsFlipping(true);
      setTimeout(() => {
        setCurrentPage(currentPage + 1);
        setIsFlipping(false);
      }, 600);
    }
  };

  const prevPage = () => {
    if (currentPage > 0 && !isFlipping) {
      setIsFlipping(true);
      setTimeout(() => {
        setCurrentPage(currentPage - 1);
        setIsFlipping(false);
      }, 600);
    }
  };

  return (
    <section id="menu" className="menu-section">
      <div className="menu-container">
        <div className="menu-header animate-fade-in-up">
          <h2 className="section-title">Our Menu</h2>
          <div className="title-divider"></div>
        </div>

        <div className="menu-book">
          <div className={`menu-page ${isFlipping ? 'flipping' : ''}`}>
            <div className="page-content">
              <h3 className="page-title">{pages[currentPage].title}</h3>
              {pages[currentPage].subtitle && (
                <p className="page-subtitle">{pages[currentPage].subtitle}</p>
              )}
              <div className="menu-items">
                {pages[currentPage].items.map((item, index) => (
                  <div key={index} className="menu-item">
                    <span className="item-name">{item.name}</span>
                    <span className="item-dots"></span>
                    <span className="item-price">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="menu-navigation">
            <button 
              onClick={prevPage} 
              className="btn-glass nav-btn"
              disabled={currentPage === 0}
            >
              <ChevronLeft size={20} />
              Previous
            </button>
            <span className="page-indicator">
              Page {currentPage + 1} of {pages.length}
            </span>
            <button 
              onClick={nextPage} 
              className="btn-glass nav-btn"
              disabled={currentPage === pages.length - 1}
            >
              Next
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;